'use client';

import { useEffect, useRef } from 'react';
import { useSession } from '@/hooks/use-session';
import { useConsent } from '@/providers/consent-provider';

/**
 * Bridges the auth session with the consent provider.
 * When a logged-in user has accepted analytics consent via terms acceptance,
 * this component tells the ConsentProvider to auto-grant GA and hide the Klaro banner.
 */
export function UserConsentBridge() {
  const { data: session, status } = useSession();
  const { setUserConsent } = useConsent();
  const appliedRef = useRef(false);

  useEffect(() => {
    if (appliedRef.current) return;
    if (status !== 'authenticated') return;
    // Wait until terms are accepted before applying consent decision
    if (!session?.user?.termsAcceptedAt) return;

    appliedRef.current = true;
    setUserConsent(!!session.user.analyticsConsentAt);
  }, [status, session?.user?.termsAcceptedAt, session?.user?.analyticsConsentAt, setUserConsent]);

  return null;
}
